import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import React from 'react';
import { httpService } from '../../../services/http.service';
import { IFormData } from '../../../flows/achOutTransfer/constants';
import { IServerErrorResponse } from '../../../types';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';
import LiliNotification, { LiliNotificationType } from '../../../DesignSystem/LiliNotification/LiliNotification';
import { LiliToastDefaultConfig } from '../../../DesignSystem/LiliToast/LiliToast';
import { endpointManager } from '../../../services/endpoint.service';

export interface IAchOutResponse {
  processTime: string;
  status: string;
  transactionId: string;
}

interface IProps {
  formData: IFormData;
  billId?: string;
  supplierId?: string;
}

export const postAchOutReview = () => {
  const { postAchOutReviewUrl } = endpointManager();

  return useMutation('send-ach-out', async ({ formData, billId, supplierId }: IProps) => {
    const { transferAmount } = formData;

    const { data } = await httpService.post(postAchOutReviewUrl(billId), {
      amount: Number(transferAmount),
      feeData: formData.feeData,
      supplierId,
    });
    return data.mfaActionData;
  }, {
    onError: (error: IServerErrorResponse) => {
      const { localizedMessage } = flattenServerErrorResponse(error);
      toast(<LiliNotification undismissable type={LiliNotificationType.ERROR} text={localizedMessage} id='vendorDetailsError' />, { ...LiliToastDefaultConfig });
    },
  });
};
